<template>
    <section class="basic-query">
      <h4>一、基础查询功能</h4>
      
      <!-- 综合查询 -->
      <section class="query-module">
        <h4><a href="https://t.me/ZLSGK/71">📱 综合查询</a> </h4>
        <p>费用：普通用户1积分/次，会员免费｜查无结果不扣费</p>
        <div class="content-section">
          <h5>可查内容：</h5>
          <ul>
            <li>1大类
              <ul>
                <li>姓名/身份证/手机/密码/账号</li>
                <li>邮箱（QQ/工作/主邮箱等）</li>
                <!-- 其他列表项 -->
              </ul>
            </li>
            <!-- 其他分类内容 -->
          </ul>
        </div>
      </section>
  
      <!-- 补齐查询 -->
      <section class="query-module">
        <h4>2大类</h4>
        <p>费用：普通用户2积分/次，会员免费</p>
        <!-- 身份证补齐和手机号补齐内容 -->
      </section>
  
      <!-- 猎魔查询 -->
      <section class="query-module">
        <h4>3大类</h4>
        <p>费用：普通用户2积分/次，会员免费</p>
        <!-- 普通猎魔和自然语言猎魔内容 -->
      </section>
    </section>
  </template>
  
  <script>
  export default {
    name: 'BasicQuerySection'
  }
  </script>
  
  <style scoped>
  .query-module {
    margin-bottom: 2em;
    padding: 15px;
    background: #f8f9fa;
    border-radius: 8px;
  }
  
  .content-section h5 {
    margin: 1em 0 0.5em;
    color: #444;
  }
  </style>